import Options from '../../components/Options/Options';
import Connect from '../../components/Connect/Connect';
import Solutions from '../../components/Solutions/Solutions';
import Benefits from '../../components/Benefits/Benefits';
import Gaming from '../../components/Gaming/Gaming';
import Partners from '../../components/Partners/Partners';
import ListConect from '../../components/ListConect/ListConect';
import Started from '../../components/Started/Started';
import Features from '../../components/Features/Features';
import Modal from '../../components/Modal/Modal';
import { useState } from 'react';
import PopUp from '../../components/PopUp/PopUp';
import { FormData } from '../../types/types';
import Button from '../../components/Button/Button';
import CookiePopup from '../../components/CookiePopup/CookiePopup';

const Main = () => {
  const [isRequestSent, setIsRequestSent] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const handleSubmit = (formData: FormData) => {
    console.log(formData);
    setIsOpen(false);
  };

  return (
    <>
      <Connect setIsRequestSent={setIsRequestSent} />
      <ListConect className='list' />
      <Options />
      <Solutions openModal={openModal} />
      <Benefits children='Find out more' openModal={openModal} />
      <Features />
      <Gaming openModal={openModal} />
      <Started openModal={openModal} />
      <Partners startIndex={0} />
      {isRequestSent ? (
        <Modal
          isOpen={isRequestSent}
          onClose={() => setIsRequestSent(false)}
          className='thank-popup popup'
          title='Thank you!'
        >
          <p className='popup__text text-large '>
            Your request has been successfully sent.
          </p>
          <p className='popup__text text-large '>
            Our expert will contact you soon.
          </p>
          <Button
            className='popup__button'
            type='button'
            onClick={() => setIsRequestSent(false)}
          >
            Close
          </Button>
        </Modal>
      ) : (
        <Modal
          isOpen={isOpen}
          onClose={closeModal}
          className='popup'
          title='Share your request with our sales team'
        >
          <PopUp
            className='form-popup'
            onSubmit={handleSubmit}
            setIsOpen={setIsOpen}
            setIsRequestSent={setIsRequestSent}
          />
        </Modal>
      )}
      <CookiePopup className='cookie' />
    </>
  );
};
export default Main;
